import styled from "styled-components";

import RunwayLogoMark from "@img/miniLogoRunway.svg";
import AdminSessionBar from "@pages/AdminDashboard/AdminSessionBar";
import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

import { AdminNavigationList } from "./AdminNavigationList";
import { AdminTag } from "./AdminTag";
import { narrowWindowWidth } from "./layout";

const { color } = adminTokens;
const [, spaceSm, , , spaceLg] = adminTokens.spacing;
// The design's sidebar: 240px wide, 20px above and below, 14px at each side.
const sidebarWidth = 240;
const sidebarPaddingY = spaceLg;
const sidebarPaddingX = 14;
const brandPaddingX = 10;
const brandPaddingBottom = 22;
const logoSize = 32;

const Sidebar = styled.aside`
  display: flex;
  flex: none;
  flex-direction: column;
  box-sizing: border-box;
  width: ${sidebarWidth}px;
  padding: ${sidebarPaddingY}px ${sidebarPaddingX}px;
  background-color: ${color.surface};
  border-right: 1px solid ${color.border};
  color: ${color.navy};

  @media (max-width: ${narrowWindowWidth - 1}px) {
    width: 100%;
    border-right: 0;
    border-bottom: 1px solid ${color.border};
  }
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: ${spaceSm}px;
  padding: 4px ${brandPaddingX}px ${brandPaddingBottom}px;
`;

const BrandLogo = styled.img`
  flex: none;
  width: ${logoSize}px;
  height: ${logoSize}px;
`;

const Spacer = styled.div`
  flex: 1;
`;

// The desktop sidebar: the brand, the admin's navigation and the admin's own session
// controls at the foot (SHELL-R2…R14).
export const AdminSidebar = () => (
  <Sidebar>
    <Brand>
      <BrandLogo src={RunwayLogoMark} alt="Runway Health" />
      <AdminTag>Admin</AdminTag>
    </Brand>
    <AdminNavigationList placement="sidebar" />
    <Spacer />
    <AdminSessionBar />
  </Sidebar>
);
